/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const membershipBulkOperationSchema = z.object({
  resourceIds: z.array(z.int()).min(1),
  teamIds: z.array(z.int()).min(1),
});
